export default {"src":"/_next/static/media/MOS.dc1b5bc4.svg","height":18,"width":18};